jQuery(document).ready(function ($) {
  $(".product-card__quick-add-button").on("click", function (e) {
    e.preventDefault();

    const button = $(this);
    const productId = button.val();
    const quantity = 1; // Default quantity

    $.ajax({
      url: safariAjax.ajax_url,
      type: "POST",
      dataType: "json",
      data: {
        action: "safari_quick_add_to_cart",
        product_id: productId,
        quantity: quantity,
      },
      beforeSend: function () {
        button.prop("disabled", true).text("Adding...");
      },
      success: function (response) {
        if (response.success) {
          alert(response.data.message);
          $(".cart-count").text(response.data.cart_count);
          $(".cart-total").html(response.data.cart_total);
        } else {
          alert(response.data.message);
        }
      },
      complete: function () {
        button.prop("disabled", false).text("Buy now");
      },
      error: function () {
        alert("Something went wrong. Please try again.");
      },
    });
  });
});
